//import logger from '../../services/logger';

const Sell = () => {
};

export default Sell;